import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.architecture');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-architecture',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.architecture/view.scss */
.architecture-page {
  min-height: 100vh;
  background: #f5f7fb;
  color: #111827;
  padding: 32px;
}

.architecture-head,
.explanation-grid,
.pipeline-panel,
.grouping-panel,
.architecture-detail-grid,
.error-banner {
  max-width: 1480px;
  margin: 0 auto 18px;
}

.architecture-head {
  display: grid;
  gap: 18px;
}

.title-block .eyebrow {
  margin: 0 0 10px;
  color: #0f766e;
  font-size: 13px;
  font-weight: 850;
  letter-spacing: 0;
  text-transform: uppercase;
}
.title-block h1 {
  margin: 0;
  color: #0f172a;
  font-size: 38px;
  font-weight: 850;
  line-height: 1.14;
  letter-spacing: 0;
}
.title-block .summary {
  max-width: 860px;
  margin: 14px 0 0;
  color: #475569;
  font-size: 16px;
  line-height: 1.6;
}

.top-links {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 18px;
}

.nav-link {
  display: inline-flex;
  align-items: center;
  min-height: 36px;
  border: 1px solid #cbd5e1;
  border-radius: 6px;
  background: #ffffff;
  color: #0f172a;
  padding: 0 12px;
  font-size: 13px;
  font-weight: 850;
  text-decoration: none;
}
.nav-link:hover {
  border-color: #0f766e;
  background: #f0fdfa;
  color: #0f766e;
}

.error-banner {
  border: 1px solid #fecdd3;
  border-radius: 8px;
  background: #fff1f2;
  color: #be123c;
  padding: 12px 14px;
  font-size: 14px;
  font-weight: 750;
}

.explanation-grid {
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 12px;
}

.explanation-card,
.pipeline-panel,
.grouping-panel,
.detail-panel {
  border: 1px solid #dbe3ef;
  border-radius: 8px;
  background: #ffffff;
  box-shadow: 0 12px 30px rgba(15, 23, 42, 0.06);
}

.explanation-card {
  display: grid;
  align-content: start;
  gap: 10px;
  min-height: 180px;
  padding: 16px;
}
.explanation-card h2 {
  margin: 0;
  color: #0f172a;
  font-size: 16px;
  font-weight: 900;
}
.explanation-card p {
  margin: 0;
  color: #475569;
  font-size: 13px;
  font-weight: 700;
  line-height: 1.55;
}

.pipeline-panel,
.grouping-panel,
.detail-panel {
  padding: 18px;
}

.panel-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 14px;
}
.panel-head h2 {
  margin: 0;
  color: #0f172a;
  font-size: 17px;
  font-weight: 850;
  letter-spacing: 0;
}
.panel-head span {
  color: #64748b;
  font-size: 13px;
  font-weight: 750;
}

.pipeline-grid {
  display: grid;
  grid-template-columns: repeat(6, minmax(0, 1fr));
  gap: 10px;
}

.pipeline-step {
  display: grid;
  align-content: start;
  gap: 10px;
  min-height: 190px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #f8fafc;
  padding: 14px;
}
.pipeline-step .step-index {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border-radius: 999px;
  background: #e0f2fe;
  color: #0369a1;
  font-size: 13px;
  font-weight: 950;
}
.pipeline-step h3 {
  margin: 0;
  color: #0f172a;
  font-size: 15px;
  font-weight: 900;
}
.pipeline-step p {
  margin: 0;
  color: #475569;
  font-size: 12px;
  font-weight: 700;
  line-height: 1.5;
}

.grouping-layout {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px;
}

.group-column {
  display: grid;
  align-content: start;
  gap: 10px;
}
.group-column h3 {
  margin: 0;
  color: #0f172a;
  font-size: 15px;
  font-weight: 900;
}

.grouping-card {
  display: grid;
  gap: 6px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #f8fafc;
  padding: 12px;
}
.grouping-card strong {
  color: #0f766e;
  font-size: 13px;
  font-weight: 900;
}
.grouping-card span {
  color: #475569;
  font-size: 13px;
  font-weight: 750;
  line-height: 1.5;
  overflow-wrap: anywhere;
}

.direction-note {
  margin: 0;
  border-left: 4px solid #0f766e;
  background: #ecfdf5;
  color: #134e4a;
  padding: 12px 14px;
  font-size: 13px;
  font-weight: 800;
  line-height: 1.55;
}

.architecture-detail-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}

.contract-list {
  display: grid;
  grid-template-columns: 108px minmax(0, 1fr);
  gap: 12px 16px;
  margin: 0;
}
.contract-list dt {
  color: #475569;
  font-size: 13px;
  font-weight: 850;
}
.contract-list dd {
  margin: 0;
  color: #111827;
  font-size: 13px;
  font-weight: 700;
  line-height: 1.55;
  overflow-wrap: anywhere;
}

.artifact-list {
  display: grid;
  gap: 10px;
  max-height: 460px;
  overflow: auto;
}
.artifact-list article {
  display: grid;
  gap: 6px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #f8fafc;
  padding: 12px;
}
.artifact-list strong {
  color: #0f172a;
  font-size: 14px;
  font-weight: 900;
}
.artifact-list code {
  color: #0f766e;
  font-size: 12px;
  white-space: normal;
  overflow-wrap: anywhere;
}
.artifact-list span {
  color: #64748b;
  font-size: 12px;
  font-weight: 700;
  line-height: 1.45;
}

.risk-list {
  display: grid;
  gap: 10px;
  margin: 0;
  padding-left: 20px;
  color: #334155;
  font-size: 14px;
  font-weight: 750;
  line-height: 1.55;
}

@media (max-width: 1180px) {
  .explanation-grid,
  .pipeline-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .architecture-detail-grid {
    grid-template-columns: 1fr;
  }
  .grouping-layout {
    grid-template-columns: 1fr;
  }
}
@media (max-width: 720px) {
  .architecture-page {
    padding: 18px;
  }
  .title-block h1 {
    font-size: 30px;
  }
  .explanation-grid,
  .pipeline-grid,
  .contract-list {
    grid-template-columns: 1fr;
  }
  .panel-head {
    align-items: flex-start;
    flex-direction: column;
  }
}`],
})
export class PageArchitectureComponent implements OnInit {
    public doc: any = null;
    public error: string = "";

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init(this);
        await this.load();
    }

    public async load(): Promise<void> {
        try {
            const response: any = await wiz.call("load");
            if (!response || response.code !== 200) {
                throw new Error("Architecture document request failed");
            }
            this.doc = response.data;
        } catch (error: any) {
            this.error = error && error.message ? error.message : String(error);
        }
        await this.service.render();
    }

    public modelState(): string {
        if (!this.doc || !this.doc.model || !this.doc.model.state) return "";
        return this.doc.model.state.join(", ");
    }

    public modelAction(): string {
        if (!this.doc || !this.doc.model || !this.doc.model.action) return "";
        return this.doc.model.action.join(", ");
    }
}

export default PageArchitectureComponent;